

const Mision = () => {

  return (
    <section className="w-[90%] mx-auto flex flex-col lg:flex-row gap-14 justify-center lg:items-center pt-10 md:pt-24">
      {/* CONTENIDO */}
      <div className="flex flex-col lg:pr-20">
        <h2 className="text-[25px] lg:text-[35px] leading-10 mt-5 max-w-[500px] font-tommy-medium uppercase">Misión</h2>
        <p className="text-base mt-4 font-tommy-light max-w-[600px]">Facilitar el proceso de pre inversión e inversión en proyectos municipales financiados por CODEDEH, proporcionando una herramienta digital ágil, accesible y transparente que promueva la eficiencia en la planificación, ejecución y seguimiento de proyectos para el bienestar de la comunidad de Huehuetenango</p>
      </div>
      {/* IMAGEN */}
      <div className="flex justify-center w-full lg:w-[673px] h-[328px] lg:-order-1 lg:pl-20">
        <img src="/images/mision1.jpeg" className="w-full h-full object-cover object-center" />
      </div>
      {/* IMAGEN */}
      {/* <div className="lg:hidden flex justify-center lg:w-[473px] h-[428px]">
        <img src="/images/mision2.jpeg" className="w-full h-full object-cover object-center" />
      </div> */}
    </section>
  );
}

export default Mision;